import React, { Component, Fragment,createRef } from 'react'

import PropTypes from 'prop-types'

import '../../assets/css/marker.css';



import GoogleMapReact from 'google-map-react';
import Config from 'Config'
import seller from '../../store/reducers/seller';
import { getNearByRequestServiceCancelledSellers, getNearByRequestServiceSellers, getServiceSellersByLocation } from '../../services/Services';

import { getNearByRequestServiceSubscribedSellers , getNearByRequestServiceSellersBySubStatus} from '../../services/Services';

import mapUtilityMethods from '../../utils/mapUtilityMethods';
import Marker from './Marker';
import { IN_TRIAL , ACTIVE} from 'constants/SellerSubscriptionStatus';
import _ from 'lodash';

let circleRemoveTimeOut;

const initialState = {
  sellers: [],
  sellersPopulated: false,
  defaultCenter: {},
  zoomLevel: 0,
  api:false,
  map : {},
  maps : {},
  currentCircleObject : {},
  activeCircleSeller:{},
}

/*const Marker = props => {
  return <>
    <div ><img className="pin" src={marker} title={props.title}></img></div>
    <div className="pulse"></div>
    <div className="map-pin-text" onMouseOver={this.onMapPinHover}>{<b>{props.title}</b>}</div >

  </>
}*/

const MyMarker = props => {
  return <>
    <div className="my-pin"></div>


  </>
}

const StartEndMarker = props => {
  return <>
    <div>{props.start ? <div className="start-pin">A</div> : <div className="end-pin">B</div>}</div>


  </>
}
//const Marker = ({ text }) => <div>adsfasdfasdfasdf</div>;
export class GMapsContainer extends Component {

  getInfoWindowString = seller => `
    <div>
      <div style="font-size: 16px;">
        ${seller.name}
      </div>
      <div style="font-size: 14px;">
        <span style="color: grey;">
        ${seller.rating}
        </span>
        <span style="color: orange;">${String.fromCharCode(9733).repeat(Math.floor(seller.rating))}</span><span style="color: lightgrey;">${String.fromCharCode(9733).repeat(5 - Math.floor(seller.rating))}</span>
      </div>
      <div style="font-size: 14px; color: grey;">
        ${place.types[0]}
      </div>
      <div style="font-size: 14px; color: grey;">
        ${'$'.repeat(place.price_level)}
      </div>
      <div style="font-size: 14px; color: green;">
        ${place.opening_hours.open_now ? 'Open' : 'Closed'}
      </div>
    </div>`;

  constructor(props) {
    super(props);
    this.state = initialState;

    this.googleMapRef = createRef();
  }

  async componentDidMount() {

    if (this.props.defaultCenter && this.props.serviceID && !this.state.sellersPopulated) {
      const { serviceID } = this.props;

      const { lat, lng } = this.props.buyerLocation ?  this.props.buyerLocation : this.props.defaultCenter;
      if(lat != 0 && lng != 0)
      {    
        getNearByRequestServiceSellersBySubStatus(serviceID, lat, lng, ACTIVE)
        .then((res) => {
          const sellers = _.filter(res.data, s=> !_.isNull(s));
          
          this.setState({ sellers: sellers, sellersPopulated: true, defaultCenter: this.props.buyerLocation }, () => {
            const maxDistanceInMeteres = this.getMaxDistanceFromCenter(this.props.buyerLocation, this.state.sellers);
            const zoomLevel = mapUtilityMethods.getZoomLevelByDistance(maxDistanceInMeteres);
            this.setState({ zoomLevel: zoomLevel+1 })
            if(this.props.onSellersLoad){
              this.props.onSellersLoad(sellers);
            }
          });
        })
        .catch(() => {
          //this.props.showNotificationMessage(ERROR, 'Service pin toggle failed.');
        });
      }
    }

  }

  async componentDidUpdate(prevProps, prevState) {
    try {
     
      if (
          (this.props && this.props.defaultCenter 
          && this.props.serviceID  
          && this.props.nearByProsSelectedStatus 
          && !this.state.sellersPopulated 
          && this.state.sellersPopulated != prevState.sellersPopulated)
          || this.props.serviceID != prevProps.serviceID 
          || this.props.buyerLocation != prevProps.buyerLocation
          || this.props.nearByProsSelectedStatus != prevProps.nearByProsSelectedStatus 
          || (this.props.reload != prevProps.reload && this.props.reload === true)
        ) {

        const { serviceID } = this.props;
        const { lat, lng } = this.props.buyerLocation ? this.props.buyerLocation : this.props.defaultCenter;

        let res;
        let nearByProsSelectedStatus = this.props.nearByProsSelectedStatus;
        res = await getNearByRequestServiceSellersBySubStatus(serviceID, lat, lng , nearByProsSelectedStatus)
      
        const sellers = _.filter(res.data, s => !_.isNull(s));

        this.setState({ sellers: sellers, sellersPopulated: true, defaultCenter: this.props.buyerLocation }, () => {
          const maxDistanceInMeteres = this.getMaxDistanceFromCenter(this.props.buyerLocation, this.state.sellers);
          const zoomLevel = mapUtilityMethods.getZoomLevelByDistance(maxDistanceInMeteres);
          this.setState({ zoomLevel: zoomLevel + 1 });
          if (this.props.onSellersLoad) {
            this.props.onSellersLoad(sellers);
          }
        });
      }

      if (this.props.selectedSeller != prevProps.selectedSeller) {

        this.googleMapRef.current.props.onGoogleApiLoaded({ map: this.state.map, maps: this.state.maps });

      } else if (this.props.selectedSeller.sellerID == prevProps.selectedSeller.sellerID && this.state == prevState) {
        if (Object.entries(this.state.activeCircleSeller).length > 0 &&
          this.state.activeCircleSeller.sellerID == this.props.selectedSeller.sellerID) {
          // remove circle if save seller is selected again.
          this.setState({ activeCircleSeller: {} })
          this.state.currentCircleObject.setMap(null);
          if (circleRemoveTimeOut) {
            clearTimeout(circleRemoveTimeOut)
          }
        } else {
          // again draw circle if click on same seller.
          this.googleMapRef.current.props.onGoogleApiLoaded({ map: this.state.map, maps: this.state.maps });
        }
      }
    } catch (e) {
      console.log("error in : componentDidUpdate")
      console.log(e)
    }
  }

  createMapOptions = (maps) => {
    return {
      fullscreenControl: false,
    }
  }

  getMaxDistanceFromCenter = (defaultCenter, sellers) => {
    let maxDistance = 0;
    if (defaultCenter && !_.isEmpty(sellers)) {
      sellers.map((seller) => {
        let distance = mapUtilityMethods.getDistance(defaultCenter, { lat: seller.seller.lat, lng: seller.seller.lon });

        if (distance > maxDistance) {
          maxDistance = distance;
        }
      })
    }


    return maxDistance;
  }

  onMarkerMouseOver = (sellerID) => {
    if (this.props.onMarkerMouseOver) {
      this.props.onMarkerMouseOver(sellerID);
    }
  }

  onMarkerMouseOut = (sellerID) => {
    if (this.props.onMarkerMouseOut) {
      this.props.onMarkerMouseOut(sellerID);
    }
  }

  onMarkerClick = (selectedSeller) => {
    if (this.props.onMarkerClick) {
      this.props.onMarkerClick(selectedSeller);
    }

  }


  apiIsLoaded = (map, maps , selectedSeller) => {   
    try {
      let circle;
      if (google && selectedSeller && !_.isEmpty(selectedSeller)) {
        circle = new google.maps.Circle({
          strokeColor: "#FF0000",
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: "#FF0000",
          fillOpacity: 0.3,
          map,
          center: { lat: parseFloat(selectedSeller.lat), lng: parseFloat(selectedSeller.lon) },
          radius: mapUtilityMethods.convertMilesIntoMeters(selectedSeller.serviceRadius ? selectedSeller.serviceRadius : 0)
        });
      }
      if (this.state.currentCircleObject && Object.entries(this.state.currentCircleObject).length) {
        this.state.currentCircleObject.setMap(null);
      }
      this.setState({ map: map, maps: maps, currentCircleObject: circle  , activeCircleSeller : selectedSeller })

      if(circleRemoveTimeOut)
      {
        clearTimeout(circleRemoveTimeOut)
      }
      circleRemoveTimeOut = setTimeout(() => {
        if (this.state.currentCircleObject && Object.entries(this.state.currentCircleObject).length) {
          this.state.currentCircleObject.setMap(null);
          this.setState({ activeCircleSeller: {} })
        }
      }, 10000);

    } catch (e) {
      console.log("Error in apiIsLoaded().")
      console.log(e);
    }
  };

  render() {
    // const { selectedSeller} = this.state;

    return (
      <Fragment>
        {
          <GoogleMapReact
            ref={this.googleMapRef}
            bootstrapURLKeys={{ key: Config.maps.key, language: 'en', region: 'us', libraries: ['places'] }}
            defaultZoom={1}
            yesIWantToUseGoogleMapApiInternals={true}
            zoom={this.state.zoomLevel}
            center={this.props.defaultCenter || this.props.buyerLocation }
            options={this.createMapOptions}
            onGoogleApiLoaded={({ map, maps }) => this.apiIsLoaded(map, maps , this.props.selectedSeller)}
          >
            {
              this.state.sellers && this.state.sellers.map(data =>
                (<Marker 
                    seller={data.seller}
                    trial={data.seller.subStatus == IN_TRIAL} 
                    subscribed={data.seller.sellerPlan ? true : false}
                    lat={data.seller.lat} 
                    lng={data.seller.lon} 
                    title={data.seller.name} 
                    phone={data.seller.cellPhone} 
                    sellerid={data.seller.sellerID} 
                    selectedSeller={this.props.selectedSeller} 
                    status={data.seller.subStatus }
                    onMarkerMouseOver={this.onMarkerMouseOver} 
                    onMarkerMouseOut={this.onMarkerMouseOut} 
                    onMarkerClick={() => this.onMarkerClick(data.seller , false)}  />)
              )
            }
            {//this.props.usingCurrentLocation &&
              <MyMarker lat={this.props.buyerLocation ? this.props.buyerLocation.lat : this.props.defaultCenter.lat} lng={this.props.buyerLocation ? this.props.buyerLocation.lng : this.props.defaultCenter.lng} />
            }
            {
              this.props?.sbr?.postProcessing?.distance?.sourceAddressLatLng && this.props?.sbr?.postProcessing?.distance?.destinationAddressLatLng && 
              
              <StartEndMarker start lat={this.props.sbr.postProcessing.distance.sourceAddressLatLng.lat} lng={this.props.sbr.postProcessing.distance.sourceAddressLatLng.lng} />
              
              
            }
            {
              this.props?.sbr?.postProcessing?.distance?.sourceAddressLatLng && this.props?.sbr?.postProcessing?.distance?.destinationAddressLatLng && 
              
              
              <StartEndMarker lat={this.props.sbr.postProcessing.distance.destinationAddressLatLng.lat} lng={this.props.sbr.postProcessing.distance.destinationAddressLatLng.lng} />
              
            }
          </GoogleMapReact>
        }
      </Fragment>
    )
  }
}

/*GMapsContainer.propTypes = {
    sellers: PropTypes.array.isRequired,
    defaultCenter: PropTypes.object
}*/

export default GMapsContainer
